<template>
    <div>

        <div class="order-car-form card">
            <div class="card-body text-left">
                <div class="form-title">
                    {{form_title[locale]}}
                </div>

                <div class="form-anons">
                    {{form_anons[locale]}}
                </div>

                <form v-show="!sent">
                    <div class="form-group">
                        <input class="form-control" name="phone" v-model="phone" :placeholder="phone_title[locale]">
                    </div>

                    <div class="form-group">
                        <input class="form-control" name="name" v-model="name" :placeholder="name_title[locale]">
                    </div>

<!--                    <div class="form-group">-->
<!--                        <select class="form-control">-->
<!--                            <option>{{car_name}}</option>-->
<!--                        </select>-->
<!--                    </div>-->


<!--                    <div class="form-group">-->
<!--                        <div class="custom-control custom-switch">-->
<!--                            <input type="checkbox" class="custom-control-input" id="customSwitch2" v-model="accept_date">-->
<!--                            <label class="custom-control-label" for="customSwitch2">{{date_txt[locale]}} </label>-->
<!--                        </div>-->
<!--                    </div>-->

<!--                    <div class="form-group">-->
<!--                        <div class="custom-control custom-switch">-->
<!--                            <input type="checkbox" class="custom-control-input" id="customSwitch1" v-model="accept">-->
<!--                            <label class="custom-control-label" for="customSwitch1">{{personal_title[locale]}} </label>-->
<!--                        </div>-->
<!--                    </div>-->

                    <div class="form-group">
                        <VueCtkDateTimePicker
                            color="#005F96"
                            format="YYYY-MM-DD"
                            :formatted="locale == 'ru' ? 'DD MMMM YYYY' : 'll'"
                            :auto-close="true"
                            :only-date="true"
                            :min-date="min_date"
                            :range="true"
                            :no-shortcuts="true"
                            :locale="locale"
                            :label="date_label[locale]"
                            :no-header="true"
                            :no-label="true"
                            v-model="dates" />
                    </div>

                    <div class="form-group">
                        <button class="btn btn-primary btn-lg btn-block"  @click.prevent="sendForm()"
                                :disabled="!isFormValid || sending">
                            <i class="fa fa-spinner fa-pulse fa-fw" v-show="sending"></i>
                            {{btn_name[locale]}}
                        </button>
                    </div>

                </form>


                <div v-show="sent">
                    <div class="alert alert-success">
                        {{form_msg_sended[locale]}}
                    </div>
                </div>

            </div>



        </div>
    </div>
</template>

<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

    export default {
        name: "callback-form",
        props: ['locale','id','car_name'],
        components: { VueCtkDateTimePicker },
        data: function () {
            return {
                sent: false,
                sending: false,
                accept: false,
                accept_date: false,
                name: '',
                phone: '',
                dates: '',
                isPhoneErr: false,
                comments: '',
                isCommentsErr: false,
                btn_name: {
                    'en': 'Request',
                    'ru': 'Отправить',
                },
                form_title: {
                    'en': 'Request price',
                    'ru': 'Получить предложения по специальное цене',
                    //'ru': 'Оставить заявку',
                },
                form_anons: {
                    'en': 'The price may vary depending on the season and days of the week',
                    'ru': '',
                    //'ru': 'Цена меняться в зависимости от сезона и дней недели',
                },
                phone_title: {
                    'en': 'Phone*',
                    'ru': 'Номер вашего телефона*',
                },
                name_title: {
                    'en': 'Name',
                    'ru': 'Имя',
                },
                date_label: {
                    'en': 'Select dates',
                    'ru': 'Выбрать даты',
                },
                date_txt: {
                    'en': 'I know the exact rental date',
                    'ru': 'Я знаю точную дату аренды',
                },
                personal_title: {
                    'en': 'I consent to the processing of my personal data',
                    'ru': 'Я даю согласие на обработку своих персональных данных',
                },
                form_msg_sended: {
                    'en': 'Request is sent!',
                    'ru': 'Заявка отправлена!',
                },
                form_btn_send: {
                    'en': 'Send',
                    'ru': 'Отправить',
                },
            }
        },

        computed: {
            isFormValid() {

                if (this.phone.length === 0) {
                    this.isPhoneErr = true;
                    return false;
                }

                // if (this.accept === false) {
                //     return false;
                // }

                // if (this.accept_date === false) {
                //     return false;
                // }

                return true;
            },

            min_date() {
                var currentDate = new Date()
                var day = currentDate.getDate()
                var month = currentDate.getMonth() + 1
                var year = currentDate.getFullYear()
                var today =( year + "-" + month + "-"  + day)
                return today;
            },
        },


        watch: {
            phone: function (val) {
                this.isPhoneErr = val.length === 0;
            },

            comments: function (val) {
                this.isCommentsErr = val.length === 0;
            },
        },

        methods: {
            async sendForm() {
                if (this.sending) {
                    return;
                }

                if (!this.isFormValid) {
                    return;
                }
				
				
				let formData = new FormData();
				formData.append('phone', this.phone);
				formData.append('id', this.id);
				formData.append('car_name', this.car_name);
				formData.append('name', this.name);
				formData.append('dates', JSON.stringify(this.dates));
				

                this.sending = true;
				
				try {
					let response = await axios.post('/requestCar', formData);
					this.sent = true;
					
					let page_url = response.data.page_url ? response.data.page_url : window.location.href;
					
					gtag('event', 'special', {
						'event_category': 'forms',
						'event_label': 'forms',
						'value': page_url
					});
					
					let ym_counter = (this.locale == 'ru' ? 86416587 : 86416566);
					ym(ym_counter, 'reachGoal', 'special');
				} catch (error) {
					console.log(error);
				}
	            
	            this.sending = false;
				
            },


        },

	    
        created() {
        },

        mounted() {
			//console.log('car book form mounted');
        }
    }
</script>


<style lang="scss">
.order-car-form {
        display: inline-block;
        max-width:385px;
        &.card {
            border: 1px solid #F0F0F0;
            box-sizing: border-box;
            border-radius: 8px;
        }
        .card-body {
	        
            padding:30px;
            .form-title {
                font-weight: 700;
                font-size: 24px;
                line-height: 30px;
                color: #333333;
                margin-bottom:10px;
            }
            .form-anons {
                font-style: normal;
                font-weight: normal;
                font-size: 16px;
                line-height: 26px;
                color: #333333;
                margin: 8px 0px 30px 0;
            }
            form {
                // margin:10px 0;
                .form-group {
                    margin-bottom:22px;
                }
                .form-control {
                    height:50px;
                    background: #F0F0F0;
                    border-radius: 8px 8px 0px 0px;
                    border-color: #F0F0F0;
                    border-bottom: 2px solid #C79C6E ;
                    //padding:16px;
                }
                select.form-control {
                    -moz-appearance: none;
                    -webkit-appearance: none;
                    appearance: none;
                    background-position: right center;
                    background-repeat: no-repeat;
                    background-size: 1ex;
                    background-origin: content-box;
                    background-image: url("data:image/svg+xml;base64,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");
                }
            }
        }
}
</style>
